const NAMED: Record<string, string> = {
	ArrowUp: "↑",
	ArrowDown: "↓",
	ArrowLeft: "←",
	ArrowRight: "→",
	Space: "Space",
	Tab: "Tab",
	Enter: "Enter",
	NumpadEnter: "Num Enter",
	Escape: "Esc",
	Backspace: "Backspace",
	CapsLock: "Caps",
	ShiftLeft: "Left Shift",
	ShiftRight: "Right Shift",
	ControlLeft: "Left Ctrl",
	ControlRight: "Right Ctrl",
	AltLeft: "Left Alt",
	AltRight: "Right Alt",
	MetaLeft: "Left Win",
	MetaRight: "Right Win",
	ContextMenu: "Menu",
	Backquote: "`",
	Minus: "-",
	Equal: "=",
	BracketLeft: "[",
	BracketRight: "]",
	Backslash: "\\",
	Semicolon: ";",
	Quote: "'",
	Comma: ",",
	Period: ".",
	Slash: "/",
};

/** Human-readable label for a `KeyboardEvent.code` (physical key, US layout names). */
export function keyLabel(code: string): string {
	const named = NAMED[code];
	if (named) return named;
	if (/^Key[A-Z]$/.test(code)) return code.slice(3);
	if (/^Digit\d$/.test(code)) return code.slice(5);
	if (/^Numpad\d$/.test(code)) return `Num ${code.slice(6)}`;
	if (/^F\d{1,2}$/.test(code)) return code;
	return code.replace(/([a-z])([A-Z])/g, "$1 $2");
}
